/**
 * Apunta el favicon del documento a `href`: reutiliza el `<link rel="icon">` existente (el de `public/index.html`)
 * o crea uno en `<head>` si no hay. Devuelve el `<link>` usado.
 */
export const setFavicon = (href: string, doc: Document = document): HTMLLinkElement => {
    let link = doc.querySelector<HTMLLinkElement>('link[rel~="icon"]');
    if (!link) {
        link = doc.createElement('link');
        link.rel = 'icon';
        doc.head.appendChild(link);
    }
    link.href = href;
    return link;
};
